import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import { configAxios } from '@/plugins/axios';
import { configSentry } from '@/plugins/sentry';
import { configI18n } from '@/plugins/i18n';

import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/en';
import Vuelidate from 'vuelidate';
import ElementUI from 'element-ui';
import vueMoment from 'vue-moment';
import VueCurrencyInput from 'vue-currency-input';

configSentry();
configAxios();
configI18n();

Vue.use(vueMoment);
Vue.use(Vuelidate);
Vue.use(ElementUI, { locale });
Vue.use(VueCurrencyInput, { globalOptions: { currency: 'EUR' }});
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
